<div class="my-3 my-md-5">
    <div class="container-fluid px-4">
            <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2">
                          <!-- <input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadleads(0,perpage)" placeholder="Search" /> -->
                          <input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" />
                        </div>
                        <div class="col-sm-2">
                          <!-- <mat-select  placeholder="Lead Source" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="lead_source" multiple> -->
                            <mat-select  placeholder="Lead Source" [(ngModel)]="lead_source" multiple>
                              <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2">
                          <!-- <mat-select  placeholder="Circle" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="circle_data_filter" multiple> -->
                            <mat-select  placeholder="Circle" [(ngModel)]="circle_data_filter" multiple>
                            <mat-option value="{{circle.id}}" *ngFor="let circle of circle_filter">{{circle.name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2">
                          <!-- <mat-select  placeholder="BD's" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="bd_data_filter" multiple> -->
                            <mat-select  placeholder="BD's" [(ngModel)]="bd_data_filter" multiple>
                            <mat-option value="{{bds.id}}" *ngFor="let bds of bd_filter">{{bds.name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2">
                          <!-- <mat-select  placeholder="Status" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="status_data_filter" multiple> -->
                            <mat-select  placeholder="Status" [(ngModel)]="status_data_filter" multiple>
                            <mat-option value="{{status_f.id}}" *ngFor="let status_f of status_filter">{{status_f.name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2">
                          <!-- <mat-select  placeholder="Category" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="category_data_filter" multiple> -->
                            <mat-select  placeholder="Category" [(ngModel)]="category_data_filter" multiple>
                            <mat-option value="{{cat_f.id}}" *ngFor="let cat_f of category_filter">{{cat_f.name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                          <!-- <mat-select  placeholder="Treatment Catergory" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="lead_category_filter" multiple> -->
                            <mat-select  placeholder="Treatment Catergory" [(ngModel)]="lead_category_filter" multiple>
                              <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                          <!-- <mat-select  placeholder="Treatment" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple> -->
                            <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                              <input class="mySearchInput"
                              #treatmentSearch focused="'true'" type="text"
                              (keyup)="searchOnSelect($event.target.value, 'treatment')"
                              (keydown)="$event.stopPropagation()" autocomplete="off"
                              placeholder="Search"
                              id="treatmentSearch">
                              <!-- <mat-option >All</mat-option> -->
                              <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of alltreatments">{{ltreatment.name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                          <!-- <mat-select  placeholder="Payment Mode" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="payment_mode" multiple> -->
                            <mat-select  placeholder="Payment Mode" [(ngModel)]="payment_mode" multiple>
                              <!-- <mat-option >All</mat-option> -->
                              <mat-option value="Cash">Cash</mat-option>
                              <mat-option value="Cashless">Cashless</mat-option>
                              <mat-option value="Reimbursement">Reimbursement</mat-option>
                              <mat-option value="EMI">EMI</mat-option>
                          </mat-select>
                        </div>

                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Created On Date Range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate('created_on')">clear</mat-icon>
                        </div>

                        <div class="col-sm-3 mt-2" >
                          <mat-form-field appearance="fill">
                              <mat-label>Enter Followup date range</mat-label>
                              <mat-date-range-input [rangePicker]="followuppicker">
                                  <input matStartDate #followupdateRangeStart placeholder="Start date">
                                  <input matEndDate #followupdateRangeEnd placeholder="End date" (dateChange)="followupdateRangeChange(followupdateRangeStart, followupdateRangeEnd)">
                              </mat-date-range-input>
                              <mat-datepicker-toggle matSuffix [for]="followuppicker"></mat-datepicker-toggle>
                              <mat-date-range-picker #followuppicker></mat-date-range-picker>
                          </mat-form-field>
                          <mat-icon (click)="clearDate('followup')">clear</mat-icon>
                      </div>

                       
                        <div class="col-sm-3 mt-2">
                          <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadleads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                          <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                        </div>

                        <div class="col-sm-2 mt-2">
                          <span>
                              <div><a class="btn btn-success text-white" (click)="showModalTest()"><i class="fa fa-file-excel"></i> Import Lab Test Details</a><br></div>
                              <a href="{{s3url}}crm/sample-lab-test-detail.csv" target="_blank">Sample CSV Lab Test</a>
                          </span>
                      </div>

                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1'">
                          <span>
                              <div><a class="btn btn-success text-white" (click)="showModalAddLead()"><i class="fa fa-file-excel"></i> Import Lab Leads</a><br></div>
                              <a href="{{s3url}}crm/sample-add-lab-lead.csv" target="_blank">Sample CSV Lab Lead</a>
                          </span>
                      </div>

                    </div>
                    
                </mat-expansion-panel>
            </mat-accordion>

        <div class="card">
            <div class="container-fluid row">

              <div class="col-sm-8 p-3">
                <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="loadleads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh Sheet</button>

                <button type="button" *ngIf="(myrole=='1' || myrole=='17' ||  myrole=='18')" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="exportData()"><i class="fa fa-file-excel"></i> Export</button>

                <button *ngIf="myrole=='1' || myrole=='17'" type="button" class="btn btn-success ml-2 mb-4" (click)="open_category_modal()"> <i class="fa fa-plus"></i> Add Category</button>

                <button *ngIf="myrole=='1' || myrole=='17'" type="button" class="btn btn-success ml-2 mb-4" (click)="open_sub_category_modal()"> <i class="fa fa-plus"></i> Add Sub Category</button>
               

                <!-- <a *ngIf="myrole=='1' || myrole=='17'" routerLink="/create-lead" class="btn btn-success ml-2 mb-4">
                  <i class="fa fa-plus" aria-hidden="true"></i> Add Surgery Lead
                </a> -->
              </div>
            
                <div class="col-sm-4">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
            <div class="text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <hot-table [hotId]="id" [colHeaders]="true" [hiddenColumns]="hideColumn" [columnSorting]="false" width="100%" [height]="600" [rowHeaders]="true" [data]="leads" [beforeChange]="onBeforeChange" [afterOnCellMouseDown]="afterOnCellMouseDownCallBack"  licenseKey="non-commercial-and-evaluation" [autoWrapRow]="false" [autoWrapCol]="false">
                
                <hot-column data="glamyo_patient_id" renderer="html" [readOnly]="true" title="Glamyo Patient Id"></hot-column>
                <hot-column data="lead_name" title="Patient Name"></hot-column>
                <hot-column [copyable]="false" data="mobile" renderer="html" [readOnly]="true" title="Patient Mobile"></hot-column>
                <hot-column [readOnly]="true" renderer="html" data="source_name" title="Lead Source"></hot-column>

                <!--------Nimbus Click to Call----------->
                <!-- <hot-column renderer="html" data="nimbus_click_to_call" [readOnly]="true" title="Nimbus C2C"></hot-column> -->
                <!--------Nimbus Click to Call----------->

                <!--------Kaleyra Click to Call----------->
                <hot-column renderer="html" data="click_to_call" [readOnly]="true" title="Kaleyra C2C"></hot-column>
                <!--------Kaleyra Click to Call----------->

                <hot-column renderer="html" data="share_plan" [readOnly]="true" title="Share Plan"></hot-column>

                <hot-column data="created_at" [readOnly]="true" title="Lead Created Time"></hot-column>
                <hot-column data="patient_age" title="Patient Age"></hot-column>
                <hot-column data="gender" type="dropdown" [source]="gender" title="Gender"></hot-column>

                <hot-column data="city_name" [readOnly]="true" title="City Name"></hot-column>
                <hot-column data="lead_circle" type="dropdown" [source]="sheetCircle" title="To Circle"></hot-column>

                <hot-column data="treatment_name" [readOnly]="true" title="Treatment"></hot-column>
                <hot-column data="treatment_categories_name" [readOnly]="true" title="Treatment Category"></hot-column>
                <hot-column data="payment_mode" type="dropdown" allowEmpty="true" [source]="paymentOpt" title="Payment Mode"></hot-column>

                <hot-column data="bd_name" [readOnly]="true" title="Lead Owner Name"></hot-column>
                <hot-column data="bd_email" [readOnly]="roleStatus" type="dropdown" [source]="bds" title="Lead Owner Email"></hot-column>
                <hot-column data="lead_status_name" type="dropdown" [source]="leadStatusOpt" title="Lead Status"></hot-column>
                <hot-column data="description" title="Description" width="300"></hot-column>
                <hot-column data="bd_description" title="BD Description" [readOnly]="true" width="300"></hot-column>
                <hot-column data="category_test_name" [readOnly]="true" title="Test Category"></hot-column>
                <hot-column data="test_name" [readOnly]="true" title="Test Subcategory"></hot-column>
                <hot-column data="lab_name" [readOnly]="true" title="Lab Name"></hot-column>
                <hot-column data="followup_date" type="date" allowEmpty="true" dateFormat='DD/MM/YYYY' title="Followup Date"></hot-column>

                <hot-column data="sample_collection_date" [readOnly]="true" title="Sample Collection Date/Test"></hot-column>
                
                <hot-column data="report_generated_date" type="date" allowEmpty="true" dateFormat='DD/MM/YYYY' title="Report Generated Date"></hot-column>
                <hot-column data="test_report" renderer="html" [readOnly]="true" title="View Report"></hot-column>
                
                
                <hot-column [readOnly]="true" renderer="html" data="utm_source" title="Form Lead Source"></hot-column>
                <hot-column [readOnly]="true" renderer="html" data="utm_medium" title="Form Lead Medium"></hot-column>
                <hot-column [readOnly]="true" renderer="html" data="utm_campaign" title="Form Lead Campaign"></hot-column>
                
                <hot-column [readOnly]="true" renderer="html" data="created_by_name" title="Created By"></hot-column>
                <hot-column data="action" width="200px" type="dropdown" [source]="ActionOpt" title="Action"></hot-column>
                <!-----------Share App Link------------->
                <hot-column renderer="html" data="is_appLink_sent" [readOnly]="true" title="Share App Link Status"></hot-column>
                <hot-column renderer="html" data="send_applink" [readOnly]="true" title="Share App Link"></hot-column>
                <!-----------Share App Link------------->
                <hot-column [readOnly]="true" data="first_action_date_time" title="First Action On (Date & Time)" *ngIf="userId=='253' || myrole=='1'"></hot-column>
                <hot-column renderer="html" data="lead_history" [readOnly]="true" title="History" *ngIf="myrole=='1'"></hot-column>
            </hot-table>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>


<!-- Lab Test import modal -->
<!-- The Modal -->
<div class="modal fade" id="myModalfb">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Lab Test Data </h4>
          <button type="button" class="close" (click)="hideModalTest()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadTest (change)="selectFileLabTest($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalTest()">Close</button>
        </div>
      </div>
    </div>
</div>


<!------------For Show lead History------------------->
<!-- The Modal to view history -->
<div class="modal fade" id="myHistoryModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
          <h4 class="modal-title">Update History</h4>
          <button type="button" class="close" (click)="closeHistoryPopup()"></button>
      </div>
      <div class="modal-body history_modal">
          <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
            <tbody>
                <tr *ngFor="let updatedLog of updatedLodData">
                    <td class="no-padding-bottom">
                        <div class="small_text" style="white-space: pre-line;" [innerHTML]="updatedLog.message | safe:'html'"></div>
                        <div class="small text-muted small_text_creation">
                            <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy H:mm aa'}}
                        </div>
                    </td>
                </tr>
                <tr *ngIf="!updatedLodData.length && history_loaded">
                    <td>No history found</td>
                </tr>
                <tr *ngIf="history_loading">
                    <td><i class="fa fa-spin fa-spinner"></i></td>
                </tr>
            </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-----------------For Nimbus Click to Call-------------------------->
<div class="modal fade" id="nimbus_click_to_call_progress" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" style="font-weight: bold;">Nimbus Call Progression</h4>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group">
            <div class="row">
              <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                <i class="fa fa-cog fa-spin"></i><br />
                <h2>Nimbus Call is under progress.</h2>
              </div>
            </div>
          </div>
        </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" [disabled]="nimbus_end_to_call_btn_disable" class="btn btn-success" (click)="endNimbusClicktoCall()">Close</button>
      </div>
    </div>
  </div>
</div>


<!-----------------For Click to Call-------------------------->
<div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" style="font-weight: bold;">Call Progression</h4>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
              <div class="alert alert-danger" *ngIf="progression_msg">
                <strong>Warning!</strong> {{progression_msg}}
              </div>
              <div class="form-group">
                <div class="row">
                  <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                    <i class="fa fa-cog fa-spin"></i><br />
                    <h2>Call is under progress.</h2>
                  
                  </div>
                </div>
              </div>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- Lab Test import modal -->
<!-- The Modal -->
<div class="modal fade" id="myModalAddLead">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Import Lab Leads Data </h4>
        <button type="button" class="close" (click)="hideModalAddLead()"></button>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
            <div class="form-group">
                <div class="row">
                    <label class="col-sm-12">Upload CSV</label>
                    <input [disabled]="submitted" type="file" #csvUploadLead (change)="selectFileLabLeads($event)" class="form-control" />
                </div>
                <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn" (click)="hideModalAddLead()">Close</button>
      </div>
    </div>
  </div>
</div>





 


